<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-20" *ngIf="isHeaderEnabled">
                <label class="col-xs-12">
                    {{ "control_fields_appearance" | translate }}
                </label>
                <div class="col-xs-12">
                    <div class="btn-group d-flex">
                        <button
                            class="btn btn-grey w-100"
                            [class.active]="iconPositionType.value === iconPosition.SITE"
                            (click)="setIconPositionType(iconPosition.SITE)"
                        >
                            <img src="./assets/img/websites/cart/lpc-site-icon.svg" alt="site" />
                        </button>
                        <button
                            class="btn btn-grey w-100"
                            [class.active]="iconPositionType.value === iconPosition.HEADER"
                            (click)="setIconPositionType(iconPosition.HEADER)"
                        >
                            <img src="./assets/img/websites/cart/lpc-header-icon.svg" alt="header" />
                        </button>
                    </div>
                </div>
                <div class="col-xs-12">
                    <p class="help-block text-muted small">
                        {{
                            (iconPositionType.value === iconPosition.SITE
                                ? "shop_cart_icon_site"
                                : "shop_cart_icon_header"
                            ) | translate
                        }}
                    </p>
                </div>
            </div>
            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "shop_cart_icon_type" | translate }}
                </label>
                <div class="col-xs-12">
                    <div class="appearance-wrapper">
                        <div
                            class="appearance-block"
                            *ngFor="let el of CART_ICON_TYPES"
                            [ngClass]="{ active: iconType.value === el.type }"
                            (click)="setIconTypeType(el.type)"
                        >
                            <div class="cart-icon-wrapper" [ngStyle]="getIconStyles()">
                                <span class="icon-counter" [ngStyle]="getCounterStyles()">1</span>
                                <div
                                    [innerHTML]="getIcon(el.label)"
                                    [ngStyle]="previewIconSizeStyle()"
                                    class="icon"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group mb-20" *ngIf="!isMobile">
                <div class="col-xs-10">
                    <label class="control-label">{{ "shop_cart_icon_color" | translate }}</label>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="iconColor.value"
                        (colorChangeEvent)="setItemColor($event, iconColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20" *ngIf="iconPositionType.value === iconPosition.SITE">
                <div class="col-xs-10">
                    <label class="control-label">{{ "shop_cart_icon_bg_color" | translate }}</label>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="iconBgColor.value"
                        (colorChangeEvent)="setItemColor($event, iconBgColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-10">
                    <label class="control-label">{{ "shop_cart_icon_counter_color" | translate }}</label>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="iconCounterColor.value"
                        (colorChangeEvent)="setItemColor($event, iconCounterColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-10">
                    <label class="control-label">{{ "shop_cart_icon_counter_bg_color" | translate }}</label>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="iconCounterBgColor.value"
                        (colorChangeEvent)="setItemColor($event, iconCounterBgColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20" *ngIf="iconPositionType.value === iconPosition.SITE">
                <div class="col-xs-6">
                    <label class="control-label">{{ "control_radius" | translate }}</label>
                </div>
                <div class="col-xs-6">
                    <sp-input-num
                        prefixImgUrl="./assets/img/border-radius-icon.svg"
                        suffixText="px"
                        [min]="BORDER_RADIUS_MIN"
                        [max]="BORDER_RADIUS_MAX"
                        [value]="iconRounding.value"
                        (valueChange)="setIconRoundingRounding($event)"
                        (blurEvent)="setIconRoundingRounding($event)"
                    ></sp-input-num>
                </div>
            </div>

            <div class="form-group mb-20" *ngIf="!isMobile">
                <div class="col-xs-6">
                    <label class="control-label">{{ "shop_cart_icon_size" | translate }}</label>
                </div>
                <div class="col-xs-6">
                    <sp-radio-group
                        [selected]="iconSize.value"
                        [type]="ERadioGroupType.size"
                        (changeSelectedEvent)="setIconSize($event)"
                    ></sp-radio-group>
                </div>
            </div>
        </div>
    </div>
</div>
